var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfStarYellowpng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    transform: "translate(0.0498047 0.859985)",
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1792_477",
    transform: "scale(0.0625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1792_477",
    width: 16,
    height: 16,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAAdgAAAHYBTnsmCAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAFWSURBVDiNlZK9S4JRGMV/zzV9pZI0dWyowT6IaC0qEpS2/oUgaClqaGxo7K9q0CUagoYKRPpCQ0gU85IIWT4tFa/mq3W289xzzj2X50IfaCZ4UnmxJ/003uYzxjXr2Eqt/mqtjXnpjGdCK7APhICR1ofu/itALxgG2fvhcFAul0f/3qDh7ABx1yRq/M52L6loJrgKuogwg5BASQATgABUF8quIhSBPEIeJWdULkWzzhUw7/VGV0AP6LWhNZQCcn1UXrjVd/+GkVTjmbZJA/f/MBd8tNPx+EjJAEiy+YTPJIGHP5iLQ6LrkUjkEVxbkJVmAZHjgXblKBwO/1zUucZ2e2qQX4RJN+/6B2Z2YAOhQ9MVoF0Beo5w3lFSZa5ngCoGIfFFCyBbrL0tx8JjS6qyCdwBiOq0qvp+NdPTUFSzTkkzzqHeEPh1rhqo1uxhpVYvWWuj3/NPlAh22kStgPsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStarYellowpng);
export default __webpack_public_path__ + "static/media/half-star-yellow.png.bbe598bd4e46fa21d5a19b45fbf0635c.svg";
export { ForwardRef as ReactComponent };